import { Grid } from '@mui/material';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomButton from '../CommonComp/Buttons/CustomButton';
import CustomBox from '../CommonComp/CustomBox/CustomBox';
import Divder from '../CommonComp/Divder';
import { updatePassword, userDetailsApi } from '../../Services/userApis';
import { userItemsSelector } from '../../redux/user';
import UserDetailInputField from './UserDetailInputField';
import { DATA_LIMIT } from '../../data/constants';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useParams } from 'react-router-dom';
import { adminAddLogs } from '../../Services/commonService';
import {
  action,
  logsMessagesList,
  modulesNames,
} from '../../data/logsMessages';
const limit = DATA_LIMIT;
function ResetPassword({}) {
  const { userId } = useParams();
  const { singleUserDetail } = useSelector(userItemsSelector);
  const dispatch = useDispatch();
  const navigate=useNavigate();

  const handleConfirm = async (values, { resetForm }) => {
    if (values.email) {
      let payload = {
        // ...values,
        user_id: values?.user_id || '',
        email: values?.email || '',
        new_password: values?.new_password?.trim() || '',
        confirm_password: values?.confirm_password?.trim(),
      };
      let resp = await updatePassword(payload);
      if (resp?.status === 200) {
        resetForm();
        let payloadForLogs = {
          action: action?.update,
          module: modulesNames?.users,
          description: logsMessagesList?.users?.userEdit,
        };
        await adminAddLogs(payloadForLogs);
        navigate('/user');
      }
     
    }
  };

  const formik = useFormik({
    initialValues: {
      user_id: userId,
      email: singleUserDetail?.items?.email?.trim() || '',
      new_password: singleUserDetail?.items?.new_password || '',
      confirm_password: singleUserDetail?.items?.confirm_password || '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      email: Yup.string()
        .email('Please enter Email')
        .required('Please enter Email'),
      new_password: Yup.string()
        .required('new password is required!')
        .max(16, 'password should be less then 16 characters')
        .min(8, 'password should be more then 8 characters')
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
          'must contain 8 characters,1 uppercase, 1 lowercase,1 number and 1 special case character',
        ),
      confirm_password: Yup.string()
        .required('Please enter confirm password!')
        .when('new_password', {
          is: (val) => (val && val.length > 0 ? true : false),
          then: Yup.string().oneOf(
            [Yup.ref('new_password')],
            'both password need to be the same',
          ),
        }),
    }),
    onSubmit: handleConfirm,
  });

  const getUserDetails = async () => {
    let payload = {
      user_id: userId,
      page: String(1),
      limit: limit - 5,
    };

    dispatch(userDetailsApi(payload));
  };

  useEffect(() => {
    getUserDetails();
  }, []);

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <CustomBox padding={3}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <UserDetailInputField
                name="email"
                label="Email"
                placeholder="Email"
                disabled
                value={formik.values.email}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  classes: {
                    notchedOutline: 'rounded',
                  },
                }}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <UserDetailInputField
                name="new_password"
                label="New Password"
                placeholder="New Password"
                value={formik.values.new_password}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  classes: {
                    notchedOutline: 'rounded',
                  },
                }}
                onChange={(e) => {
                  formik.setFieldValue('new_password', e.target.value);
                }}
                error={
                  formik.touched.new_password &&
                  Boolean(formik.errors.new_password)
                }
                helperText={
                  formik.touched.new_password && formik.errors.new_password
                }
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6}>
              <UserDetailInputField
                name="confirm_password"
                label="Confirm Password"
                placeholder="Confirm Password"
                value={formik.values.confirm_password}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  classes: {
                    notchedOutline: 'rounded',
                  },
                }}
                onChange={(e) => {
                  formik.setFieldValue('confirm_password', e.target.value);
                }}
                error={
                  formik.touched.confirm_password &&
                  Boolean(formik.errors.confirm_password)
                }
                helperText={
                  formik.touched.confirm_password &&
                  formik.errors.confirm_password
                }
              />
            </Grid>

            <Grid item xs={12} textAlign="right">
              <CustomButton type="submit" color={'buttonPrimary'}>
                Submit
              </CustomButton>
            </Grid>
          </Grid>
        </CustomBox>
      </form>

      <Divder spacing={1} />
    </div>
  );
}

export default ResetPassword;
